import { ValidateStringInput } from "../directives/validate-string-input.function";

/**
 * Request Type Strings
 * Translates to DossierTypes (BE)
 */
export enum RequestTypeEnum {
    IncomeTaxDeclaration = 'IncomeTaxDeclaration',
    VatDeclaration = "VatDeclaration",
    Unknown = 'Unknown',
    PDF = 'PDF',
    FinancialStatements = 'FinancialStatements',
    SbrAssurance = 'SbrAssurance',
    SbrNexusAssurance = "SbrNexusAssurance",
    SbrNexusAnnualReport = "SbrNexusAnnualReport",
    CorporateTaxDeclaration = 'CorporateTaxDeclaration',
    Incomplete = "Incomplete",
    AnnualFinancialFiles = "AnnualFinancialFiles",
    SbrNexusSbvReport = "SbrNexusSbvReport",
    IcpDeclaration = "IcpDeclaration",
    SafeTransfer = "SafeTransfer",
    NoabReport = "NoabReport",
    LinkingAndSigning = "LinkingAndSigning",
    WwftRequest = "WwftRequest",
    CleverbaseRequest = "CleverbaseRequest",
    CleverbaseSignYourself = "CleverbaseSignYourself",
    /**
     * Ixbrl or 'Groot' Xbrl or inline Xbrl, or zip filing
     */
    FileInlineXbrl = "FileInlineXbrl",

    WageTax = "WageTax"
    // EXTEND WHEN MORE OPTIONS FOUND
}
/**
 * Validates the given input for being an 'PDF' RequestType(Enum)
 * @param inputValidation 
 * @returns 
 */
export function Is_Pdf_RequestType(inputValidation: string): boolean {
    if (!ValidateStringInput(inputValidation)) {
        return false;
    }

    return ValidateType(inputValidation as string, RequestTypeEnum.PDF);
}
/**
 * Validates the given input for being an 'VatDeclaration' RequestType(Enum)
 * @param inputValidation 
 * @returns 
 */
export function Is_VatDeclaration_RequestType(inputValidation: string): boolean {
    if (!ValidateStringInput(inputValidation)) {
        return false;
    }

    return ValidateType(inputValidation as string, RequestTypeEnum.VatDeclaration);
}
/**
 * Validates the given input for being a RequestType(Enum) but SPECIFIC not PDF!
 * @param inputValidation 
 * @returns 
 */
export function Is_Non_Pdf_RequestType(inputValidation: string): boolean {
    if (!ValidateStringInput(inputValidation)) {
        return false;
    }

    return !ValidateType(inputValidation as string, RequestTypeEnum.PDF);
}

/**
 * Validates the given input for being an SbrNexus  RequestType(Enum)
 * - 'SbrNexusAnnualReport','SbrNexusAssurance' or 'NoabReport'
 * @param inputValidation 
 * @returns 
 */
export function Is_A_SbrNexus_RequestType(inputValidation: string): boolean {
    if (!ValidateStringInput(inputValidation)) {
        return false;
    }
    var matchedType = ValidateType(inputValidation as string, RequestTypeEnum.SbrNexusAnnualReport);
    if (matchedType) { return true; }
    matchedType = ValidateType(inputValidation as string, RequestTypeEnum.SbrNexusAssurance);
    if (matchedType) { return true; }
    return ValidateType(inputValidation as string, RequestTypeEnum.NoabReport);
}

/**
 * Validates the given input for being a "Digipoort" RequestType(Enum) 
 * - 'IncomeTaxDeclaration','IcpDeclaration,'VatDeclaration,'CorporateTaxDeclaration,'FinancialStatements,'SbrAssurance' or 'AnnualFinancialFiles'
 * @param inputValidation 
 * @returns 
 */
export function Is_A_Digipoort_RequestType(inputValidation: string): boolean {
    if (!ValidateStringInput(inputValidation)) {
        return false;
    }

    var matchedType = ValidateType(inputValidation as string, RequestTypeEnum.IncomeTaxDeclaration);
    if (matchedType) { return true; }
    matchedType = ValidateType(inputValidation as string, RequestTypeEnum.IcpDeclaration);
    if (matchedType) { return true; }
    matchedType = ValidateType(inputValidation as string, RequestTypeEnum.VatDeclaration);
    if (matchedType) { return true; }
    matchedType = ValidateType(inputValidation as string, RequestTypeEnum.CorporateTaxDeclaration);
    if (matchedType) { return true; }
    matchedType = ValidateType(inputValidation as string, RequestTypeEnum.WageTax);
    if (matchedType) { return true; }
    matchedType = ValidateType(inputValidation as string, RequestTypeEnum.FileInlineXbrl);
    if (matchedType) { return true; }

    matchedType = ValidateType(inputValidation as string, RequestTypeEnum.FinancialStatements);
    if (matchedType) { return true; }
    matchedType = ValidateType(inputValidation as string, RequestTypeEnum.SbrAssurance);
    if (matchedType) { return true; }
    return ValidateType(inputValidation as string, RequestTypeEnum.AnnualFinancialFiles);
}








function ValidateType(inputValidation: string, validationType: RequestTypeEnum): boolean {
    return inputValidation.trim().toLowerCase() == validationType.toLowerCase();
}